function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7482 0H3.25163C2.75104 0 2.28239 0.105841 1.8584 0.280294L18.4276 14.5298L22.1414 11.4605C22.1414 11.4605 22.1416 11.4602 22.1417 11.46C22.1418 11.4599 22.1421 11.4598 22.1421 11.4598L35.1419 0.280542C34.7179 0.105965 34.2489 0 33.7482 0Z",
  fill: "#3B4061"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6749 1.59888L24.4414 12.1192L36.6745 22.6396C36.8774 22.275 37.0004 21.8719 37.0004 21.4414V2.79662C37.0004 2.36636 36.8776 1.96338 36.6749 1.59888Z",
  fill: "#3B4061"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.325923 1.59839C0.12307 1.96302 0 2.36606 0 2.79657V21.4414C0 21.8716 0.122926 22.2747 0.325634 22.6392L12.5592 12.119L0.325923 1.59839Z",
  fill: "#3B4061"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9079 13.4376L19.1936 16.5074C18.9819 16.6895 18.7045 16.7805 18.4272 16.7805C18.15 16.7805 17.8725 16.6895 17.6609 16.5074L14.0912 13.4375L1.85742 23.9578C2.28148 24.1324 2.75042 24.2384 3.25116 24.2384H33.7477C34.2483 24.2384 34.717 24.1325 35.1409 23.9581L22.9079 13.4376Z",
  fill: "#3B4061"
});

var SvgShareEmail = function SvgShareEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ShareEmail.3a10cd22.svg";
export { ForwardRef as ReactComponent };